import React, { Fragment } from "react";
import styled from "styled-components";

const TopBanner = ({ loaction1, location2, place1, place2 }) => {
  return (
    <Fragment>
      <Location id="secTop">
        <Work>
          <h3>
            {/* Currently <br /> Frontend Developer */}
            {loaction1} <br /> {location2 ? location2 : ""}
          </h3>
        </Work>

        <Place>
          <h3>
            {place1} <br /> {place2}
            {/* Based in Abuja <br /> Nigeria */}
          </h3>
        </Place>
      </Location>
    </Fragment>
  );
};

export default TopBanner;

const Location = styled.section`
  width: 100%;
  display: flex;
  padding: 5rem 0;
  justify-content: space-between;

  @media screen and (max-width: 760px) {
    opacity: ${(props) => (props.variant === "about" ? 1 : 0)};
    padding-bottom: 0;
    padding: 0;
    margin-top: 4rem;
    padding-bottom: ${(props) => (props.variant === "about" ? "3rem" : 0)};
  } ;
`;

const Work = styled.div`
  width: 100%;
  text-align: center;
  font-size: 20px;
  z-index: 1;
`;

const Place = styled(Work)``;
